@if (loading) {
  <td-wb-loading-indicator position="center"></td-wb-loading-indicator>
} @else {
  <h1 class="td-wb-fpl-terms-and-conditions__header"
      translate="tdWb.fpl.termsAndConditions.HEADER"></h1>
  <div class="td-wb-fpl-terms-and-conditions__section">
    <div class="td-wb-fpl-terms-and-conditions__link">
      <a tabindex="0"
         aria-labelledby="td-wb-download-link-fpl"
         tdWbOpenWindow="link_td_fpl_terms_and_conditions">
        <td-wb-icon iconId="download--small"
                    size="14">
        </td-wb-icon>
        <span id="td-wb-download-link-fpl"
              translate="tdWb.fpl.termsAndConditions.LINK_TEXT"></span>
      </a>
    </div>
    <div class="td-wb-fpl-terms-and-conditions__body"
         [innerHtml]="fplDisclosureContent">
    </div>
  </div>
}
